import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8a0b51ec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a0b51ec')) {
      api.createRecord('8a0b51ec', component.options)
    } else {
      api.reload('8a0b51ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8a0b51ec", function () {
      api.rerender('8a0b51ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipClassroom/plusClassroom/index.vue"
export default component.exports